import { AfterContentInit, Component, Optional } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { DynamicFormService } from '@ntap/common';
import {
  DataSource,
  ItemProvider,
  ItemView,
  ItemViewProviderDirective,
  ListView,
  ListViewProviderDirective,
  NotificationService
} from '@ntap/core';
import { PrimeNGButtonActionComponent } from '@ntap/primeng';
import { debounceTime, delay, of, switchMap } from 'rxjs';
@Component({
  selector: 'app-izradi-klasifikacijsku-oznaku',
  templateUrl: '../../../shared/components/actions/common-action-template.html'
}) /* DefaultActionComponent */
export class IzradiKlasifikacijskuOznakuComponent
  extends PrimeNGButtonActionComponent
  implements AfterContentInit
{
  constructor(
    protected override notificationService: NotificationService,
    @Optional() protected override itemProvider: ItemProvider,
    protected override dataSource: DataSource,
    @Optional() protected override dynamicFormService: DynamicFormService,
    @Optional()
    protected override listViewProvider: ListViewProviderDirective<ListView>,
    @Optional() protected itemViewProvider: ItemViewProviderDirective<ItemView>
  ) {
    super(
      notificationService,
      itemProvider,
      dataSource,
      dynamicFormService,
      listViewProvider
    );
  }
  ngAfterContentInit(): void {
    this.addSubscription(
      this.itemProvider.item$
        .pipe(
          delay(0),
          switchMap(() => {
            return this.dynamicFormService.formGroup$.pipe(
              switchMap((fg) => {
                const upravniStupanj =
                  fg.get('seup~predmet~upravni_stupanj') ||
                  ({ valueChanges: of(null) } as AbstractControl);
                console.log(upravniStupanj);
                return upravniStupanj.valueChanges;
              })
            );
          })
        )
        .subscribe((upravniStupanj) => {
          console.log(upravniStupanj);
          if (upravniStupanj) {
            (this.itemViewProvider.viewState as any)['$reload'] = true;
            (this.itemViewProvider.viewState as any)[
              'seup~predmet~upravni_stupanj'
            ] = upravniStupanj;
            this.itemViewProvider.reload();
          }
        })
    );
    this.addSubscription(
      this.dynamicFormService.formGroup.valueChanges
        .pipe(debounceTime(300))
        .subscribe(() => {
          const isValid = this.checkFieldsValidity();
          this.isDisabled$ = of(!isValid);
        })
    );
  }

  checkFieldsValidity(): boolean {
    const inputFields = [
      'seup~predmet~upravni_stupanj',
      'seup~predmet~vr_klasifikacija'
    ];
    const fieldValidityChecks = inputFields.map((fieldName) => {
      const control = this.dynamicFormService.formGroup.get(fieldName);
      return control && control.value && control.valid;
    });
    return fieldValidityChecks.every((isValid) => isValid);
  }

  protected override initDisabledObservable(): void {
    this.isDisabled$ = of(!this.checkFieldsValidity());
  }
}
